import { render, staticRenderFns } from "./UploadFileIcon.vue?vue&type=template&id=eff7119e&scoped=true&"
import script from "./UploadFileIcon.vue?vue&type=script&lang=js&"
export * from "./UploadFileIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff7119e",
  null
  
)

export default component.exports